import { getServiceURL } from './transportWrapper';
import { IGridState } from './types';

const gridStateApi = getServiceURL(process.env.CLASSIC_GRID_STATE_HOST);

export const gridStateById = async (gridStateId: string, clientOptions?: RequestInit): Promise<IGridState> => {
  return gridStateApi
    .options(clientOptions, true)
    .url(`/api/v1/grid_state/${gridStateId}`)
    .get()
    .json()
    .then((gridState: { grid_state: IGridState }): IGridState => {
      return gridState.grid_state;
    });
};

export const isGeoGridState = (gridState: IGridState): boolean => {
  return ['map', 'geo'].includes(gridState.visualization.graphType);
};
